import React from 'react';
import styled, { css } from 'styled-components';

import Button from '@components/Forms/FormButton';

const StyleTextAndButton = styled.p(
  ({ theme }) => css`
    color: ${theme.colors.gray600};
    margin: 0;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    display: flex;
    align-items: center;
  `
);

const StyleButtonLink = styled(Button)(
  ({ theme }) => css`
    width: auto;
    padding: 0;
    margin: 0 0 0 8px;
    color: ${theme.colors.gbrand500};
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    display: flex;
    align-items: center;
  `
);

const TextAndLink = ({ children, textLink, onClick, disabled }) => (
  <StyleTextAndButton>
    {children}
    {textLink && (
      <StyleButtonLink type="link" onClick={onClick} disabled={disabled}>
        {textLink}
      </StyleButtonLink>
    )}
  </StyleTextAndButton>
);

export default TextAndLink;
